import { dataService } from '../api/api';

export const makeRequest = (endpoint, method, body = null) => {
    return new Promise((resolve) => {
      dataService.requestData(endpoint, method, body)
        .then(data => {
          if (!data) {
            console.error(`No data received for ${method} ${endpoint}`);
            resolve({ success: false, message: 'No data received from server' });
            return;
          }
          resolve(data);
        })
        .catch(error => {
          console.error(`API error for ${method} ${endpoint}:`, error.message);
          // Return consistent error format instead of rejecting
          resolve({ success: false, message: error.message || 'Request failed' });
        });
    });
};
